module.exports = "<video #video width=\"100%\" style=\"margin: 0.5rem 0;\"></video>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/barcode-scanner/scanner/scanner.component.html
// module id = 2588
// module chunks = 66